<template>
    <ModalComponent
        name="cargar-usuarios"
        title="Cargar usuarios"
        @close="close(false)"
    >
        <b-row>
             <b-col cols="12">
                <div class="form-group">
                    <label for="tipo">Selecciona el tipo de carga de usuarios</label>
                    <ValidationProvider name="tipo">
                        <multiselect 
                            placeholder="Selecciona el tipo de carga de usuarios"
                            :options="tipos"
                            id="tipos"
                            label="label"
                            track-by="id"
                            v-model="tipo"
                        ></multiselect>
                    </ValidationProvider>
                </div>
            </b-col>
            <b-col cols="12" v-if="tipo?.id === 2">
                <div class="form-group" v-if="eventos.length">
                    <label for="provincias">Selecciona el evento del que quieres cargar los usuarios</label>
                    <ValidationProvider name="evento">
                        <multiselect 
                            placeholder="Eventos"
                            :options="eventos"
                            :value="eventos.id"
                            id="eventos"
                            label="name"
                            track-by="id"
                            v-model="evento"
                            :max-height="138"
                        ></multiselect>
                    </ValidationProvider>
                </div>
                <div class="text-center" v-else>
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Cargando...</span>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" class="mt-2 text-right">
                <Button @click="cargarUsuarios" :disabled="!tipo || (tipo.id === 2 && !evento)">Cargar usuarios</Button>
            </b-col>
        </b-row>
    </ModalComponent>  
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: {
        comunicado_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            tipo: null,
            evento: null,
            eventos: [],
            tipos: [
                { id: 1, label: 'Abonados activos' },
                { id: 2, label: 'Eventos' }
            ]
        }
    },
    methods: {
        getEventos() {
            const data = {
                filters: {
                    to_select: true
                }
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                this.eventos = res.data;
            }).catch(error => {
                this.$toast.error(error.response?.data?.message);
            });
        },
        cargarUsuarios() {
            const data = {
                filters: {},
                comunicado_id: this.comunicado_id,
                tipo: this.tipo.id
            };

            if (this.evento) {
                data.evento_id = this.evento.id;
            }

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.cargar-users'), data).then(res => {
                this.$toast.success(res.data?.message);
                this.close(true);
            }).catch(error => {
                this.$toast.error(error.response?.data?.message);
            });
        },
        close(recargar) {
            this.tipo = null;
            this.evento_id = null;
            this.$emit('close', 'cargar-usuarios', recargar);
        }
    },
    watch: {
        'tipo.id': function(newVal) {
            if (newVal === 2) {
                this.getEventos();
            }
        }
    },
    components: {
        ModalComponent
    }
}
</script>